import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { SETTINGS_GROUPS } from "@/lib/nav";
import { useSession } from "@/context/SessionContext";
import { PageHeader } from "@/components/common/States";

export default function SettingsPage() {
  const { can } = useSession();
  return (
    <div data-testid="settings-page">
      <PageHeader title="Settings" subtitle="Approvals, records, company setup and other tools." />
      <div className="space-y-8">
        {SETTINGS_GROUPS.map((g) => {
          const items = g.items.filter((i) => can(i.perm));
          if (!items.length) return null;
          return (
            <section key={g.label}>
              <h2 className="text-sm font-semibold text-muted-foreground mb-3">{g.label}</h2>
              <div className="g39-card divide-y">
                {items.map((i) => (
                  <Link key={i.key} to={i.path} className="flex items-center gap-3 px-4 py-3.5 hover:bg-secondary" data-testid={`settings-link-${i.key}`}>
                    <i.icon className="h-[18px] w-[18px] text-gold" />
                    <span className="flex-1 text-sm font-medium">{i.label}</span>
                    <ChevronRight className="h-4 w-4 text-muted-foreground" />
                  </Link>
                ))}
              </div>
            </section>
          );
        })}
      </div>
    </div>
  );
}
